import { Divider, Typography } from '@mui/material';
import { map, sortBy } from 'lodash';
import React, { Fragment, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { UseQueryResult } from 'react-query';

import { DataWrapper, DateLabel } from 'components';
import { OrderStatus } from 'enums';
import { TranslationNamespace } from 'i18n';
import {
  OrderStatusHistory as OrderStatusHistoryType,
  PayinOrder,
} from 'types';
import { formatUtils, orderUtils } from 'utils';

type Props = {
  order: PayinOrder;
  loading: boolean;
  statusHistoryQueryResult: UseQueryResult<OrderStatusHistoryType[]>;
};

export const OrderStatusHistory: React.FC<Props> = ({
  order,
  loading,
  statusHistoryQueryResult,
}: Props) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.orders.table.columns',
  });

  const renderHistoryStatusItem = useCallback(
    (status: OrderStatus, statusDate: Date) => (
      <div className="tw-my-1">
        <Typography color="textSecondary">
          {orderUtils.getStatusLabel(status)}
        </Typography>
        <DateLabel>{formatUtils.formatDate(statusDate)}</DateLabel>
      </div>
    ),
    [],
  );

  return (
    <Fragment>
      <Divider textAlign="left">{t('status_history')}</Divider>
      <DataWrapper isLoading={loading || statusHistoryQueryResult.isLoading}>
        <div className="tw-flex tw-flex-wrap">
          {map(
            sortBy(statusHistoryQueryResult.data, (s) => s.statusAt),
            (orderStatus, index) => (
              <div key={index} className="tw-flex tw-align-middle">
                {renderHistoryStatusItem(
                  orderStatus.status,
                  orderStatus.statusAt,
                )}
                <div className="tw-mx-2 tw-self-center">{'→'}</div>
              </div>
            ),
          )}
          {renderHistoryStatusItem(order.status, order.statusAt)}
        </div>
      </DataWrapper>
    </Fragment>
  );
};
